import setDailyTimeEntryStatusApi from './graphql/setDailyTimeEntryStatusApi';

export const setDailyTimeEntryStatus = (paramUserId, paramDateIso) => {
  return async (dispatch, getState, { client }) => {
    await setDailyTimeEntryStatusApi(client, paramUserId, paramDateIso);
  };
};
